import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService} from '../../_services/index';
import {User} from '../../_models/index';

import {LoginHelper} from '../../helpers';

const now = new Date();

@Component({
    standalone: false,
    selector: 'change-password-component',
    templateUrl: 'change.password.component.html',
  styleUrls: ['./change.password.component.scss'],

})

export class ChangePasswordComponent implements OnInit {
    loading = false;
    userId: number;
    user: User;
    oldPassword: string;
    newPassword: string;
    confirmationPassword: string;
    msg: string;

    constructor(
      public router: Router,
      public route: ActivatedRoute,
      public authenticationService: AuthenticationService,
      public userService: UserService,
      public alertService: AlertService) {

      this.userId = route.snapshot.params['userId'];
    }

    ngOnInit() {
        //console.log(this.data.user.userId);
      const tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
            this.authenticationService.logout();

            return;
        }

      let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

        this.userService.getById(currentUser.userId).subscribe(
            data => {
                this.user = data;
                //console.log(this.user);
            });
      }

    onChange() {
      const error = "The new and confirmation passwords are different.";
      if (!this.isCopyValid() || !this.isLetterValid() || !this.isNumberValid() || !this.isSizeValid() || !this.isSymbolValid()) return;

        this.loading = true;

        if (this.newPassword != this.confirmationPassword){
          this.msg = error;
            this.loading = false;
            return;
        }

        this.user.password = this.newPassword;

        this.userService.changePassword({tenantName: LoginHelper.getTenantName(), oldPassword: this.oldPassword, newPassword: this.newPassword, confirmPassword: this.confirmationPassword, userId: this.user.userId})
            .subscribe(
                data => {
                    this.alertService.success('The password was changed.', true);
                    this.user.isChangePasswordRequired = false;
                    this.user.token = LoginHelper.getUserToken();
                sessionStorage.setItem('currentUser', JSON.stringify(this.user));
                    // TODO: why do we need to terminate all sessions here?
                    //this.authenticationService.terminateSessions();
                    /*this.authenticationService.login(this.user.emailAddress, this.user.password, this.user.tenantName).subscribe(u =>
                    {*/

                  this.router.navigate(['/']);
                    //});

                    this.loading = false;
                },
                error => {
                    this.loading = false;

                    // this.msg = error.error;
                });
    }

    onClose()
    {}

  isSizeValid(){
      if (!this.newPassword) return false;
    return this.newPassword.length >=8 && this.newPassword.length < 64;
  }
  isLetterValid(){
    if (!this.newPassword) return false;
    return this.newPassword.match(/[a-z]/gi);
  }
  isNumberValid(){
    if (!this.newPassword) return false;
    return this.newPassword.match(/[0-9]/gi);
  }
  isSymbolValid(){
    if (!this.newPassword) return false;
    return this.newPassword.match(/[`\~\!\@\#\$\%\^\&\*\(\)\[\]\{\}\\\/\?\=\+\-\_\<\>\.',]/gi);
  }
  isCopyValid(){
    return this.newPassword != this.user.emailAddress && (!this.user.emailAddress || this.newPassword != this.user.emailAddress.split('@')[0]);
  }
}
